import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import ManageRecipientContent from "components/pages/AdvancedAlertsPage/components/ManageRecipientContent";
import Classes from "model";

export default function CaptureNotifiLegacyManageRecipient2(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const dataObj = { id: "0" };
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    // Sets the component to be used for the content
    .update([ "contentData" ], dataObj)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], ManageRecipientContent)
    .submit();
    
    return <AdvancedAlertsPage data={ data } ui={ ui } />
}